import React from 'react';
import axios from './axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

// eslint-disable-next-line import/prefer-default-export
export function usePostCmSubscribe() {
  const common = v => ({ data: { nominated_email: v.email, new_user: v.newUser || false } });
  const [state, q] = useAxios({
    url: '/api/v1/campaign_mailing_list/subscribe_user',
    method: 'POST',
  }, { manual: true });
  const executeQuery = React.useCallback(newParams => q(common(newParams)), [q]);
  return [state, executeQuery];
}
